export const ITEM_WIDTH = [146, 47, 24, 72, 80];
